import React, { useEffect, useState } from "react";
import "../../assets/stylesheets/CourseCard.css";
import EditIcon from "@mui/icons-material/Edit";
import PublishIcon from "@mui/icons-material/Publish";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const CourseCard = ({
  id,
  name,
  instructor,
  description,
  published,
  published_for_all,
  color,
  price,
  has_paid,
  image_url,
  font_color,
  onEdit,
  onPublish,
  onDelete,
  onSelect,
  adminStatus,
}) => {
  const styles = {
    background: image_url ? `url(${image_url}) no-repeat center/cover` : color,
    color: font_color || "inherit",
  };

  return (
    <div className="course-card" style={styles} onClick={() => onSelect(id)}>
      <div className="course-content">
        <h3 className={`course-title ${adminStatus ? "admin-mode" : ""}`}>
          {name}
        </h3>
        <p className="course-prescription">{description} </p>
        {/* <p className="instructor-name">🎓 {instructor}</p> */}
        <div className="course-price">
          <span>{price !== "0.0" ? `€${price}` : "Kostenlos"}</span>
          {price !== "0.0" &&
            (has_paid ? <LockOpenIcon /> : <ShoppingCartIcon />)}
        </div>
      </div>
      {adminStatus && (
        <div className="course-actions">
          <IconButton onClick={onEdit} aria-label="edit">
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={onPublish}
            aria-label="publish"
            title={
              published_for_all
                ? "Für alle freigegeben"
                : published
                ? "Freigegeben (Gruppen)"
                : "Nicht freigegeben"
            }
            style={{
              color: published_for_all
                ? "#4caf50"
                : published
                ? "#ffc107"
                : "rgba(255,255,255,0.5)",
            }}
          >
            <PublishIcon />
          </IconButton>
          <IconButton onClick={onDelete} aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default CourseCard;
